import { InfoSheet } from '@/shared/components/ui/InfoSheet'

export function SurvivorRulesSheet({ onClose }: { onClose: () => void }) {
  return (
    <InfoSheet title="Como funciona o Sobrevivente" onClose={onClose}>
      <InfoSheet.Section>
        <InfoSheet.Lead>
          O Sobrevivente é um mata-mata de palpites. A cada rodada, todo participante vivo
          escolhe uma seleção — e ela precisa <b>vencer</b> a partida. O último (ou últimos)
          a sobreviver leva o jogo.
        </InfoSheet.Lead>
      </InfoSheet.Section>

      <InfoSheet.Section>
        <InfoSheet.SectionTitle>Regras</InfoSheet.SectionTitle>
        <InfoSheet.List>
          <InfoSheet.Item>A cada rodada, escolha <b>um time</b> que jogue naquela rodada.</InfoSheet.Item>
          <InfoSheet.Item>O time precisa <b>vencer</b>: empate ou derrota <b>elimina</b> você.</InfoSheet.Item>
          <InfoSheet.Item>Você <b>não pode repetir</b> um time já escolhido — nem o time com que foi eliminado.</InfoSheet.Item>
          <InfoSheet.Item>Não escolher antes do fechamento da rodada também elimina (W.O.).</InfoSheet.Item>
          <InfoSheet.Item>As escolhas da rodada atual ficam ocultas até o fechamento; as de rodadas passadas ficam visíveis a todos.</InfoSheet.Item>
        </InfoSheet.List>
      </InfoSheet.Section>

      <InfoSheet.Section>
        <InfoSheet.SectionTitle>Fim de jogo</InfoSheet.SectionTitle>
        <InfoSheet.List>
          <InfoSheet.Item>Sobrou apenas um? Ele é o campeão.</InfoSheet.Item>
          <InfoSheet.Item>Se todos perderem na mesma rodada, o jogo continua na próxima com os mesmos jogadores (o time perdido segue indisponível).</InfoSheet.Item>
          <InfoSheet.Item>Se a competição terminar com mais de um vivo, todos são co-campeões.</InfoSheet.Item>
        </InfoSheet.List>
      </InfoSheet.Section>
    </InfoSheet>
  )
}
